import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { getQaSelector } from '../../../../utils/common'
import { Status } from '../../../Status'
import Text from '../../../Text'
import { useCalendarGridItemHandlers } from '../../CalendarGrid.hooks'
import {
  getCalendarGridItemTimeLabel,
  getIsCalendarGridSecondaryLabelClickable,
} from '../../CalendarGrid.utils'
import { CalendarGridItemStatus } from '../../CalendarGridItemStatus'

import { QA_NAME_CALENDAR_GRID_DAY_POPOVER_ROW } from './CalendarGridDayPopoverRow.constants'
import { CalendarGridDayPopoverRowLabels } from './CalendarGridDayPopoverRowLabels'
import { CalendarGridDayPopoverRowSubItems } from './CalendarGridDayPopoverRowSubItems'

import * as styles from './CalendarGridDayPopoverRow.module.css'

function CalendarGridDayPopoverRow({
  item = EMPTY_OBJECT,
  locale,
  timezone,
  onClickItem,
  onClickSecondaryLabel,
}) {
  const { t } = useTranslation()

  const isSecondaryLabelClickable = getIsCalendarGridSecondaryLabelClickable({
    item,
    onClickSecondaryLabel,
  })

  const { getHandleClickSubItem, handleClickItem, handleClickSecondaryLabel } =
    useCalendarGridItemHandlers({
      isSecondaryLabelClickable,
      item,
      onClickItem,
      onClickSecondaryLabel,
    })

  const { id, isAllDay, popover: { kindTag, subItems } = EMPTY_OBJECT } = item

  return (
    <div
      {...getQaSelector({
        context: id,
        value: QA_NAME_CALENDAR_GRID_DAY_POPOVER_ROW,
      })}
      className={styles.CalendarGridDayPopoverRow}
      onClick={handleClickItem}
    >
      <div className={styles.row}>
        {kindTag ? <Status {...kindTag} className={styles.tag} /> : null}
        {isAllDay ? null : (
          <Text className={styles.time}>
            {getCalendarGridItemTimeLabel({ item, locale, t, timezone })}
          </Text>
        )}
        <CalendarGridDayPopoverRowLabels
          isSecondaryLabelClickable={isSecondaryLabelClickable}
          item={item}
          onClickSecondaryLabel={handleClickSecondaryLabel}
        />
        <CalendarGridItemStatus className={styles.status} item={item} />
      </div>
      {subItems ? (
        <CalendarGridDayPopoverRowSubItems
          getHandleClickSubItem={getHandleClickSubItem}
          subItems={subItems}
        />
      ) : null}
    </div>
  )
}

export default CalendarGridDayPopoverRow
